import { useLang } from "../../context/LanguageContext";

export const Philosophy = () => {
  const { t } = useLang();
  return (
    <section data-testid="philosophy-section" className="py-20 lg:py-28 bg-[#F8F9FA] border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-px bg-[#D4AF37]" />
          <span className="overline">{t.philosophy.eyebrow}</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="border border-[#0B1F3A]/15 bg-white p-8 lg:p-10">
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#0B1F3A]/50 font-semibold">{t.philosophy.old}</div>
            <p className="mt-4 font-display text-2xl lg:text-3xl text-[#0B1F3A] font-light leading-snug">
              {t.philosophy.oldText}
            </p>
          </div>
          <div className="border border-[#0B1F3A]/15 bg-[#0B1F3A] text-white p-8 lg:p-10 relative">
            <div className="absolute top-0 right-0 w-12 h-12 border-l border-b border-[#D4AF37]" />
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37] font-semibold">{t.philosophy.new}</div>
            <p className="mt-4 font-display text-2xl lg:text-3xl font-light leading-snug">
              {t.philosophy.newText}
            </p>
          </div>
        </div>

        <div className="mt-10 border border-[#0B1F3A]/15 bg-white px-6 py-5 flex items-center justify-between flex-wrap gap-4">
          <span className="text-xs lg:text-sm font-mono text-[#0B1F3A]/80 tracking-wide">
            {t.philosophy.framework}
          </span>
          <span className="text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] font-semibold">
            {t.philosophy.tagline}
          </span>
        </div>
      </div>
    </section>
  );
};
